import { toast } from "react-toastify";
import { all, put, takeEvery, takeLatest } from "redux-saga/effects";

// Apis
import {
  downloadCityConfigExcelTemplateFn,
  getCityConfigFn,
  uploadCityConfigFn,
} from "../../apis/OrgCityConfigAPI";

// Constants and Utils
import { CityConfig } from "../../constants/action-constants/CityConfigActionConstants";
import { ReportConstants } from "../../constants/GeneralConstants";
import { getErrorMessage } from "../../utils/util";
import { saveFile } from "../../common-utils/file-utils/FileUtils";

export function* getCityConfig(action) {
  const { cityId, configType } = action.payload;

  try {
    const cityConfig = yield getCityConfigFn(cityId, configType);

    yield put({
      type: CityConfig.GET_CITY_CONFIG_SUCCESS,
      payload: { cityConfig, configType },
    });
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: CityConfig.GET_CITY_CONFIG_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export function* uploadCityConfig(action) {
  const { cityId, files, configType, isTouchPoint } = action.payload || {};

  // form data
  const formData = new FormData();
  formData.append("file", files[0]);

  try {
    yield uploadCityConfigFn(cityId, isTouchPoint, formData);

    // clear city config
    yield put({
      type: CityConfig.CLEAR_CITY_CONFIG,
    });

    // get updated city config
    if (configType) {
      yield put({
        type: CityConfig.GET_CITY_CONFIG,
        payload: { cityId, configType },
      });
    }

    // final upload success
    yield put({
      type: CityConfig.UPLOAD_CITY_CONFIG_SUCCESS,
    });

    toast.success("Successfully Uploaded.");
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: CityConfig.UPLOAD_CITY_CONFIG_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export function* downloadCityConfigExcelTemplate(action) {
  const { configType, isTouchPoint = false } = action.payload || {};

  try {
    const data = yield downloadCityConfigExcelTemplateFn(isTouchPoint);

    // file name
    const fileName = configType
      ? `${configType}_${ReportConstants.CITY_CONFIG_XLS_REPORT}`
      : ReportConstants.CITY_CONFIG_XLS_REPORT;

    // save file
    saveFile(fileName, data);

    yield put({
      type: CityConfig.DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_SUCCESS,
    });
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: CityConfig.DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export default function* root() {
  yield all([
    takeEvery(CityConfig.GET_CITY_CONFIG, getCityConfig),
    takeLatest(CityConfig.UPLOAD_CITY_CONFIG, uploadCityConfig),
    takeLatest(
      CityConfig.DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE,
      downloadCityConfigExcelTemplate
    ),
  ]);
}
